// extracted by css-extract-rspack-plugin
export default {"cls1":"Playlist-cls1_18R","cls2":"Playlist-cls2_9qb Playlist-cls1_18R"};